/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'icon-status-no-freight': {
    width: 9,
    height: 9,
    viewBox: '0 0 9 9',
    data: '<path pid="0" d="M8.082.654l.002 5.792c0 .103-.032.199-.086.278v.012a.554.554 0 0 1-.281.192l-.082.016v.574c0 .28-.205.513-.473.556l-.09.008h-.179l-.091-.008a.566.566 0 0 1-.465-.465l-.008-.091v-.569H2.644v.569c0 .28-.205.513-.473.556l-.091.008h-.178l-.091-.008a.566.566 0 0 1-.466-.465l-.007-.091v-.574l-.082-.016-.048-.02.019-.011 1.276-1.163a.54.54 0 0 0 .943-.365.54.54 0 0 0-.141-.365l1.19-1.084h2.444l-.27-1.724-.043-.217L8.082.654zM7.423.082L5.637 1.708h-3.25l-.063.353-.002.002-.288 1.858 1.175-.002L.888 6.032.89.586c0-.247.179-.453.413-.495l.09-.008 6.03-.001zM6.135 4.827a.543.543 0 1 0 0 1.085.543.543 0 0 0 0-1.085z" fill-rule="nonzero"/>'
  }
})
